import { render, staticRenderFns } from "./SimpleTableGroupList.vue?vue&type=template&id=5f7b5d49&scoped=true&"
import script from "./SimpleTableGroupList.vue?vue&type=script&lang=js&"
export * from "./SimpleTableGroupList.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTableGroupList.vue?vue&type=style&index=0&id=5f7b5d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b5d49",
  null
  
)

export default component.exports